import PHASE from 'utils/constants/phases'
import ITEM from 'utils/constants/items'

const selectors = {
    [PHASE.PRE_SEASON]: [
        {
            id: ITEM.PRE_SEASON_ENGINE,
            icon: 'engine-twinturbo',
            name: 'ENGINE',
            type: 'engine'
        },
        {
            id: ITEM.PRE_SEASON_GEARBOX,
            icon: 'gearbox-manual',
            name: 'GEARBOX',
            type: 'gearbox'
        },
        {
            id: ITEM.PRE_SEASON_WHEELS,
            icon: 'wheel-provider1',
            name: 'WHEELS PROVIDER',
            type: 'wheels'
        }
    ],
    [PHASE.PRE_RACE]: [
        {
            id: ITEM.PRE_RACE_WHEELS,
            icon: 'wheel-ultrasoft',
            label: 'TYPE OF WHEELS'
        },
        {
            id: ITEM.PRE_RACE_DRIVING,
            icon: 'drivingstyle-conservative',
            label: 'DRIVING STYLE'
        },
        {
            id: ITEM.PRE_RACE_PITSTOPS,
            icon: 'pitstops',
            label: 'PIT LANE STOPS PLAN'
        }
    ],
    [PHASE.POST_RACE]: [
        {
            id: ITEM.POST_RACE_WHEELS,
            type: 'wheels',
            icon: 'wheel-provider2',
            name: 'WHEELS',
            bullets: ['Wheel changes planned', 'Wheel actual changes', 'Extra cost planned for additional tire kits', 'Extra actual cost for additional tire kits']
        },
        {
            id: ITEM.POST_RACE_ENGINE,
            type: 'engine',
            icon: 'engine-twinturbo',
            name: 'ENGINE',
            bullets: ['Keep current item', 'Lubrication check', 'Spark plug replacement', 'Engine belt replacement', 'Replace item (engine)']
        },
        {
            id: ITEM.POST_RACE_GEARBOX,
            type: 'gearbox',
            icon: 'gearbox-manual',
            name: 'GEARBOX',
            bullets: ['Keep current item', 'Lubrication check', 'Mechanism adjustment', 'Gearbox seals adjustment', 'Replace item (gearbox)']
        }
    ]
}

export default selectors



// WEBPACK FOOTER //
// src/data/selectors.js